import React, { Component } from 'react'
import Theme from "../../assets/Theme";
import style from "../../config/style.json";
import { Container, Grid, Hidden } from '@material-ui/core';
import Background from '../../assets/images/home-login.jpg';
import Logo from '../../assets/images/logo-white.png';

export default class MainLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hash: '',
            statesLogin: {
                login: true,
                forgot: false,
                reset: false,
            }
        }
    }

    render() {
        return (
            <Theme>
                <div className={`wrapper`} styles={style}>
                    <main className={`main login`}>
                        <Container disableGutters={true} maxWidth={false} className="h-100">
                            <Grid container className="h-100">
                                <Hidden smDown>
                                    <Grid item md={4}>
                                        <div className="bg-login h-100 align-items-center" style={{ backgroundImage: `url(${Background})` }}>
                                            <img className="logo mx-auto" src={Logo} alt='SafeTravelAssistance' />
                                        </div>
                                    </Grid>
                                </Hidden>
                                <Grid item md={8} style={{ margin: "auto" }}>
                                    {this.props.children}
                                </Grid>
                            </Grid>
                        </Container>
                    </main>
                </div>
            </Theme>
        )
    }
}

